<!-- Team-interest avatar cluster: defined once, outletted into both the table
     cell and the card (let-item = the vacancy/row in either view). -->
<ng-template #teamCluster let-item>
  @if (isTeamTab && teamInterestsOf(item).length) {
    <span class="team-interest-cluster">
      @for (interest of teamInterestsOf(item).slice(0, 5); track interest.id) {
        <nb-user
          size="small"
          [onlyPicture]="true"
          [name]="colleagueName(interest)"
          [picture]="userLogo(interest.user)"
          [nbTooltip]="colleagueName(interest)"
          class="team-interest-avatar">
        </nb-user>
      }
      @if (teamInterestsOf(item).length > 5) {
        <span class="team-interest-more" [nbTooltip]="overflowColleagueNames(item)">+{{ teamInterestsOf(item).length - 5 }}</span>
      }
    </span>
  }
</ng-template>

<div class="pinned toolbar-wraps">
  <div class="title">
    <nb-route-tabset [tabs]="tabs" [fullWidth]="true" [activeLinkOptions]="{exact: false}"></nb-route-tabset>
  </div>
  <div class="buttons">
    <div class="search-input">
      <nb-icon class="search-icon" icon="search-outline"></nb-icon>
      <input nbInput #marketSearch
        type="search"
        [attr.aria-label]="'search.placeholder' | translate"
        placeholder="{{ 'search.placeholder' | translate }}"
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearchChange($event)"
        fieldSize="small">
      @if (searchQuery) {
        <button type="button" class="clear-search" (click)="clearSearch(); marketSearch.focus()" [attr.aria-label]="'shell.clear_search' | translate">
          <nb-icon icon="close-outline" aria-hidden="true"></nb-icon>
        </button>
      }
    </div>
    <div class="user-picker desktop-only">
      <bst-list-adder
        [placeholder]="'selectuser.label' | translate"
        [listTemplate]="userlisttemplate"
        [autolist]="true"
        [formControl]="curUser"
        [single]="true"
        [fullWidth]="true"
        size="small"
        status="basic"
        [filters]="{logo: true}"
        [target]="'member'">
      </bst-list-adder>
    </div>
    <span class="toolbar-divider desktop-only" aria-hidden="true"></span>
    <button nbButton ghost status="basic" size="small" class="view-toggle desktop-only"
      [nbTooltip]="(forceCards ? 'viewtable' : 'viewcards') | translate"
      (click)="toggleViewMode()"
      [attr.aria-label]="(forceCards ? 'viewtable' : 'viewcards') | translate">
      <nb-icon [icon]="forceCards ? 'list-outline' : 'grid-outline'"></nb-icon>
    </button>
    <bst-table-options-button class="desktop-only" [count]="getActiveFilterCount()" (open)="openOptions()"></bst-table-options-button>
    <button *ngIf="canManage" nbButton status="primary" shape="semi-round" size="small" type="button"
            (click)="createVacancy()">
      <nb-icon icon="plus-outline"></nb-icon> {{ 'vacancy.new_vacancy' | translate }}
    </button>
    <button class="mobile-filters" nbButton ghost (click)="openFilterSheet()">
      <nb-icon icon="funnel-outline"></nb-icon>
      {{ 'filters' | translate }}@if (getActiveFilterCount() || curUser.value) { ({{ getActiveFilterCount() + (curUser.value ? 1 : 0) }}) }
    </button>
  </div>
  @if (isActiveTab && unseenCount > 0) {
    <div class="unseen-strip">
      <button type="button" class="unseen-pill"
        [class.active]="isNewFilterActive"
        [attr.aria-pressed]="isNewFilterActive"
        [nbTooltip]="(isNewFilterActive ? 'vacancy.show_all' : 'vacancy.filter_new') | translate"
        (click)="toggleNewFilter()">
        <span class="unseen-live" aria-hidden="true"></span>
        <span class="unseen-text">{{ 'vacancy.unseen_count' | translate:{count: unseenCount} }}</span>
      </button>
      <button type="button" class="unseen-clear" (click)="markAllAsRead()">
        <nb-icon icon="checkmark-outline"></nb-icon>
        {{ 'vacancy.mark_all_as_seen' | translate }}
      </button>
    </div>
  }
  </div>
  <bst-dual-axis [tag]="'market_vacancies'" [delegate]="this" [pagingMode]="Globals.PagesMode" [experimentalGrid]="true"></bst-dual-axis>
  <ng-template #cellTemplate let-vacancy="row" let-column="column" let-node="node">
    @switch (column.name) {
      <!-- Title -->
      @case ('title') {
        <div class="title-cell">
          <button nbButton
            ghost
            size="tiny"
            [nbTooltip]="(hasHidden(vacancy) ? 'vacancy.unhide' : 'vacancy.hide') | translate"
            [attr.aria-label]="(hasHidden(vacancy) ? 'vacancy.unhide' : 'vacancy.hide') | translate"
            [attr.aria-pressed]="hasHidden(vacancy)"
            [attr.aria-busy]="isMutating(vacancy) ? true : null"
            [class.is-pending]="isMutating(vacancy)"
            status="basic"
            (click)="toggleHide(vacancy, $event)"
            class="hide-toggle">
            <nb-icon [icon]="hasHidden(vacancy) ? 'eye-off' : 'eye-outline'"></nb-icon>
          </button>
          <button nbButton
            ghost
            size="tiny"
            [style.background]="isExpired(vacancy) && !hasInterest(vacancy) ? 'none' : null"
            [nbTooltip]="'vacancy.expired' | translate"
            [nbTooltipDisabled]="!isExpired(vacancy)"
            [status]="hasInterest(vacancy) ? 'danger' : 'basic'"
            [attr.aria-label]="(hasInterest(vacancy) ? 'vacancy.withdraw' : 'vacancy.express') | translate"
            [attr.aria-pressed]="hasInterest(vacancy)"
            [attr.aria-busy]="isMutating(vacancy) ? true : null"
            [class.is-pending]="isMutating(vacancy)"
            (click)="toggleInterest(vacancy, $event)"
            class="interest-toggle">
            <nb-icon [icon]="hasInterest(vacancy) ? 'heart' : 'heart-outline'"></nb-icon>
          </button>
          <a [href]="vacancyUrl(vacancy)"
            (click)="onOpenVacancy(vacancy, $event)"
            (auxclick)="onOpenVacancy(vacancy, $event)"
            class="vacancy-link">
            {{ vacancy.title }}
          </a>
          <ng-container *ngTemplateOutlet="teamClusterOutlet; context: { $implicit: vacancy }"></ng-container>
        </div>
      }
      <!-- Company -->
      @case ('company') {
        <span>
          {{ vacancy.company || '-' }}
        </span>
      }
      <!-- Source -->
      @case ('source') {
        <span>
          {{ vacancy.source || '-' }}
        </span>
      }
      <!-- Location -->
      @case ('location') {
        <span>
          {{ vacancy.location || '-' }}
        </span>
      }
      <!-- Start Date -->
      @case ('start_date') {
        <span>
          {{ saneDate(vacancy.start_date) ? (vacancy.start_date | date: 'd MMM y') : '-' }}
        </span>
      }
      <!-- Deadline -->
      @case ('deadline') {
        <span>
          <span [class.text-danger]="isExpired(vacancy)">
            {{ saneDate(vacancy.deadline) ? (vacancy.deadline | date: 'd MMM y') : '-' }}
          </span>
        </span>
      }
      <!-- End Date -->
      @case ('end_date') {
        <span>
          {{ saneDate(vacancy.end_date) ? (vacancy.end_date | date: 'd MMM y') : '-' }}
        </span>
      }
      <!-- Posting Date -->
      @case ('posting_date') {
        <span>
          {{ saneDate(vacancy.posting_date) ? (vacancy.posting_date | date: 'd MMM y') : '-' }}
        </span>
      }
      <!-- Hard Skills -->
      @case ('skill') {
        <span>
          @if (vacancy.skills?.length) {
            {{ vacancy.skills[0]?.name }}
            @if (vacancy.skills.length > 1) {
              <span class="small-label" [nbTooltip]="Globals.makeList(vacancy.skills.slice(1), 'name')">{{ 'andmore' | translate:{value: vacancy.skills.length - 1} }}</span>
            }
          } @else {
            -
          }
        </span>
      }
      <!-- Soft Skills -->
      @case ('development') {
        <span>
          @if (vacancy.developments?.length) {
            {{ vacancy.developments[0]?.name }}
            @if (vacancy.developments.length > 1) {
              <span class="small-label" [nbTooltip]="Globals.makeList(vacancy.developments.slice(1), 'name')">{{ 'andmore' | translate:{value: vacancy.developments.length - 1} }}</span>
            }
          } @else {
            -
          }
        </span>
      }
      <!-- Certifications -->
      @case ('certification') {
        <span>
          @if (vacancy.certifications?.length) {
            {{ vacancy.certifications[0]?.name }}
            @if (vacancy.certifications.length > 1) {
              <span class="small-label" [nbTooltip]="Globals.makeList(vacancy.certifications.slice(1), 'name')">{{ 'andmore' | translate:{value: vacancy.certifications.length - 1} }}</span>
            }
          } @else {
            -
          }
        </span>
      }
      <!-- Industries: enriched relation, else the scraper's raw industry text -->
      @case ('industry_id') {
        <span>
          @if (vacancy.industries?.length) {
            {{ vacancy.industries[0]?.name }}
            @if (vacancy.industries.length > 1) {
              <span class="small-label" [nbTooltip]="Globals.makeList(vacancy.industries.slice(1), 'name')">{{ 'andmore' | translate:{value: vacancy.industries.length - 1} }}</span>
            }
          } @else {
            {{ vacancy.industry || '-' }}
          }
        </span>
      }
      <!-- Practice domains -->
      @case ('domain_id') {
        <span>
          @if (vacancy.domains?.length) {
            {{ vacancy.domains[0]?.name }}
            @if (vacancy.domains.length > 1) {
              <span class="small-label" [nbTooltip]="Globals.makeList(vacancy.domains.slice(1), 'name')">{{ 'andmore' | translate:{value: vacancy.domains.length - 1} }}</span>
            }
          } @else {
            -
          }
        </span>
      }
      <!-- New (unseen by me) -->
      @case ('is_new') {
        @if (vacancy.is_new) {
          <span class="new-badge">{{ 'vacancy.col.new' | translate }}</span>
        } @else {
          <span class="seen-badge">{{ 'vacancy.col.seen' | translate }}</span>
        }
      }
      <!-- Match Score -->
      @case ('match_score') {
        <span class="match-score-cell"
          [nbPopover]="matchPopover"
          nbPopoverTrigger="hover"
          nbPopoverPlacement="left">
          @if (vacancy.match_demoted) {
            <span class="no-score score-dash"
              [nbTooltip]="(vacancy.match_score?.best_is_fallback ? 'eligibility.fallback' : 'eligibility.demoted') | translate">&ndash;</span>
          } @else if (vacancy.match_score?.score !== null && vacancy.match_score?.score !== undefined) {
            <bst-score-selector
              [value]="vacancy.match_score.score / 100">
            </bst-score-selector>
          }
          @if (vacancy.eligibility?.verdict === 'ineligible') {
            <bst-eligibility-summary [eligibility]="vacancy.eligibility" [static]="true"></bst-eligibility-summary>
          }
          @if (!vacancy.match_demoted && (vacancy.match_score?.score === null || vacancy.match_score?.score === undefined) && !vacancy.match_score?.needs_enrichment) {
            <span
              class="no-score">
              <nb-icon icon="people-outline"></nb-icon>
            </span>
          }
          @if (vacancy.match_score?.needs_enrichment) {
            <span
              class="needs-enrichment">
              <nb-icon icon="alert-triangle-outline" status="warning"></nb-icon>
            </span>
          }
          <ng-template #matchPopover>
            <div class="match-popover">
              @if (vacancy.match_score?.selected_user) {
                <div class="best-user">
                  <a class="user-link" (click)="goToUser(vacancy.match_score.selected_user.id, $event)">
                    {{ vacancy.match_score.selected_user.name_first }} {{ vacancy.match_score.selected_user.name_last }}
                  </a>
                  @if (vacancy.match_score?.score != null) {
                    <span class="score">
                      {{ 'match score' | translate }} {{ vacancy.match_score.score | number:'1.0-0' }}/100
                    </span>
                  }
                </div>
              } @else if (vacancy.match_score?.best_user) {
                <div class="best-user">
                  <span class="label">{{ 'bestmatch' | translate }}:</span>
                  <a class="user-link" (click)="goToUser(vacancy.match_score.best_user.id, $event)">
                    {{ vacancy.match_score.best_user.name_first }} {{ vacancy.match_score.best_user.name_last }}
                  </a>
                  @if (vacancy.match_score?.score != null) {
                    <span class="score">
                      {{ 'match score' | translate }} {{ vacancy.match_score.score | number:'1.0-0' }}/100
                    </span>
                  }
                </div>
              } @else if (vacancy.match_score?.needs_enrichment) {
                <div class="no-match">
                  <nb-icon icon="alert-triangle-outline" status="warning"></nb-icon>
                  <span>Vacancy needs skill enrichment</span>
                </div>
              } @else {
                <div class="no-match">
                  <span>No matching users found</span>
                </div>
              }
            </div>
          </ng-template>
        </span>
      }
      <!-- Default -->
      @default {
        <span>
          {{ vacancy[column.name] || '-' }}
        </span>
      }
    }
  </ng-template>

  <ng-template #cardTemplate let-row="row" let-node="node">
    @let scoreTip = scoreTooltip(row);
    <div class="v-card" [class.expired]="isExpired(row)">
      <div class="v-card-head">
        <div class="v-head-main">
          <div class="v-title-row">
            @if (row.is_new) { <span class="new-dot" aria-hidden="true"></span> }
            <a class="v-title" [href]="vacancyUrl(row)" (click)="onOpenVacancy(row, $event)" (auxclick)="onOpenVacancy(row, $event)">{{ row.title }}</a>
          </div>
          <div class="v-meta">
            @if (row.company) { <span class="v-company">{{ row.company }}</span> }
            @if (row.location) { <span class="v-loc"><nb-icon icon="pin-outline"></nb-icon>{{ row.location }}</span> }
            @if (row.hours_per_week) { <span class="v-hours">{{ row.hours_per_week }}</span> }
          </div>
        </div>
        <span class="match-score-cell"
          [nbPopover]="matchPopoverCard"
          nbPopoverTrigger="click"
          nbPopoverPlacement="left"
          [nbTooltip]="scoreTip"
          [nbTooltipDisabled]="!scoreTip">
          @if (row.match_demoted) {
            <span class="no-score score-dash">&ndash;</span>
          } @else if (row.match_score?.score !== null && row.match_score?.score !== undefined) {
            <span class="score-ring" [style.--p]="row.match_score.score">
              <span>{{ row.match_score.score | number:'1.0-0' }}</span>
            </span>
          }
          @if (!row.match_demoted && (row.match_score?.score === null || row.match_score?.score === undefined) && !row.match_score?.needs_enrichment) {
            <span
              class="no-score">
              <nb-icon icon="people-outline"></nb-icon>
            </span>
          }
          @if (row.match_score?.needs_enrichment) {
            <span
              class="needs-enrichment">
              <nb-icon icon="alert-triangle-outline" status="warning"></nb-icon>
            </span>
          }
          <ng-template #matchPopoverCard>
            <div class="match-popover">
              @if (row.match_score?.selected_user) {
                <div class="best-user">
                  <a class="user-link" (click)="goToUser(row.match_score.selected_user.id, $event)">
                    {{ row.match_score.selected_user.name_first }} {{ row.match_score.selected_user.name_last }}
                  </a>
                  @if (row.match_score?.score != null) {
                    <span class="score">
                      {{ 'match score' | translate }} {{ row.match_score.score | number:'1.0-0' }}/100
                    </span>
                  }
                </div>
              } @else if (row.match_score?.best_user) {
                <div class="best-user">
                  <span class="label">{{ 'bestmatch' | translate }}:</span>
                  <a class="user-link" (click)="goToUser(row.match_score.best_user.id, $event)">
                    {{ row.match_score.best_user.name_first }} {{ row.match_score.best_user.name_last }}
                  </a>
                  @if (row.match_score?.score != null) {
                    <span class="score">
                      {{ 'match score' | translate }} {{ row.match_score.score | number:'1.0-0' }}/100
                    </span>
                  }
                </div>
              } @else if (row.match_score?.needs_enrichment) {
                <div class="no-match">
                  <nb-icon icon="alert-triangle-outline" status="warning"></nb-icon>
                  <span>Vacancy needs skill enrichment</span>
                </div>
              } @else {
                <div class="no-match">
                  <span>No matching users found</span>
                </div>
              }
            </div>
          </ng-template>
        </span>
      </div>

      @if (row.ai_summary) {
        <p class="v-summary" role="button" tabindex="0"
           (click)="onOpenVacancy(row, $event)"
           (keydown.enter)="onOpenVacancy(row, $event)">{{ row.ai_summary }}</p>
      }

      <div class="v-facts">
        @if (row.tariff) { <span class="v-fact">{{ row.tariff }}</span> }
        @if (row.source) { <span class="v-fact v-source">{{ row.source }}</span> }
      </div>

      <div class="v-skills">
        @for (s of (skillsExpanded(row.id) ? row.skills : row.skills?.slice(0,3)); track s) {
          <span class="chip">{{ s.name }}</span>
        }
        @if (row.skills?.length > 3) {
          <button class="chip more" (click)="toggleSkills(row.id, $event)">
            {{ skillsExpanded(row.id) ? ('less' | translate) : ('andmore' | translate:{value: row.skills.length - 3}) }}
          </button>
        }
      </div>

      <div class="v-card-foot">
        @if (saneDate(row.deadline)) {
          <span class="v-deadline" [class.soon]="isDeadlineSoon(row)" [class.warn]="isExpired(row)">{{ 'sort.deadline' | translate }} {{ row.deadline | date:'d MMM' }}</span>
        }
        <span class="foot-actions">
          <button class="hide-toggle" (click)="toggleHide(row, $event)" [attr.aria-pressed]="hasHidden(row)"
                  [attr.aria-label]="(hasHidden(row) ? 'vacancy.unhide' : 'vacancy.hide') | translate"
                  [attr.aria-busy]="isMutating(row) ? true : null" [class.is-pending]="isMutating(row)">
            <nb-icon [icon]="hasHidden(row) ? 'eye-off-2' : 'eye-outline'"></nb-icon>
          </button>
          <button class="interest-toggle" (click)="toggleInterest(row, $event)" [attr.aria-pressed]="hasInterest(row)"
                  [attr.aria-label]="(hasInterest(row) ? 'vacancy.withdraw' : 'vacancy.express') | translate"
                  [attr.aria-busy]="isMutating(row) ? true : null" [class.is-pending]="isMutating(row)">
            <nb-icon [icon]="hasInterest(row) ? 'heart' : 'heart-outline'"></nb-icon>
          </button>
        </span>
        <ng-container *ngTemplateOutlet="teamClusterOutlet; context: { $implicit: row }"></ng-container>
      </div>
    </div>
  </ng-template>

  <ng-template #userlisttemplate let-result="result" let-index="index">
    <nb-user color="#eee" [name]="result.name" [picture]="userLogo(result)" size="small"></nb-user>
  </ng-template>
